module.exports = __webpack_public_path__ + "img/product_86.13ec8fa.webp";